import React, { useLayoutEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import InvoiceContainer from "../../../components/Invoice/InvoiceContainer";

const CreateInvoicePage = () => {
  const location = useLocation();

  useLayoutEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.pathname]);

  return (
    <>
      <InvoiceContainer />
    </>
  );
};

export { CreateInvoicePage };
